
let baseUrl 
// "http://127.0.0.1:8600"
//https://kadsslb.mmt-ng.com

const mode = "production"  //process.env.NODE_ENV

 if (mode === 'production') {

    baseUrl = "https://kadsslb.mmt-ng.com"

 }else{

    baseUrl = "http://127.0.0.1:8600"
    
 }


module.exports =  baseUrl